import { reinit } from 'util/methods';
import { addQuestion } from '../components/question';

export const addBlankQuestion = () => {
  addQuestion(null, null);
  reinit('application', 'tooltips');
};
